var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60 60",
    width: "60px",
    height: "60px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface3520480"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.862746%,38.82353%,46.27451%)",
      fillOpacity: 1
    },
    d: "M 26 6 C 14.976562 6 6 14.976562 6 26 C 6 37.023438 14.976562 46 26 46 C 30.792969 46 35.195312 44.296875 38.644531 41.472656 L 50.585938 53.414062 C 51.085938 53.9375 51.832031 54.148438 52.535156 53.964844 C 53.234375 53.78125 53.78125 53.234375 53.964844 52.535156 C 54.148438 51.832031 53.9375 51.085938 53.414062 50.585938 L 41.472656 38.644531 C 44.296875 35.195312 46 30.792969 46 26 C 46 14.976562 37.023438 6 26 6 Z M 26 10 C 34.859375 10 42 17.140625 42 26 C 42 34.859375 34.859375 42 26 42 C 17.140625 42 10 34.859375 10 26 C 10 17.140625 17.140625 10 26 10 Z M 26 10 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a46a4b1a77e40ad4a25c54646d6a1b1d.svg";
export { ForwardRef as ReactComponent };